import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import MainHeader from '../../../headers/MainHeader/MainHeader';
import * as actions from '../../../../redux/projects/actions.projects';
import ScriptAreaMobile from '../ScriptAreaMobile/ScriptAreaMobile';
import ProjectTabs from '../ProjectTabs/ProjectTabs';
import getProjectId from '../../../../services/mini/getProjectId';
import DebuggingChat from '../DebuggingChat/DebuggingChat';
import ScriptsPanel from '../ScriptsPanel/ScriptsPanel';
import ScriptHeader from '../ScriptHeader/ScriptHeader';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import projectHelper from '../../../../services/ProjectHelper';
import ProjectHeaderMobile from '../ProjectHeaderMobile/ProjectHeaderMobile';

const tabs = [
    { key: 'scripts', name: 'Scripts' },
    { key: 'code', name: 'Code' },
    { key: 'chat', name: 'Debugging Chat' }
];

class ProjectPageMobile extends React.Component {
    constructor(props, context) {
        super(props, context);

        const environment = projectHelper.getEnvironment(this.props.projectId);

        this.state = {
            tab: 'chat',
            environment
        };
    }

    componentDidMount() {
        const { projectId, getProjectDetail } = this.props;
        let newEnvironment = projectHelper.getEnvironment(projectId);
        if (this.state.environment !== newEnvironment) {
            this.setState({ environment: newEnvironment });
        }
        getProjectDetail({ projectId, environment: newEnvironment });
    }

    componentWillUnmount() {
        const { clearChatMessages, disconnectFromProject } = this.props;
        clearChatMessages();
        disconnectFromProject();
    }

    changeTab = (tab) => {
        this.setState({ tab });
    }

    changeEnvironment = ({project, environment}) => {
        this.setState({ environment });
        this.props.changeEnvironment({ project, environment });
        this.props.rememberProjectEnvironment({
            projectId: project.projectId,
            environment: environment
        });
    }

    render() {
        const {
            scriptName,
            projectName,
        } = this.props;

        const { tab, environment } = this.state;

        return (
            <div className="project-page-mobile stage">
                <MainHeader
                    environment={environment}
                    className="project-header-with-version">
                    <ProjectHeaderMobile
                        projectName={projectName}
                        scriptName={scriptName}
                        changeEnvironment={this.changeEnvironment}
                        environment={environment} />
                </MainHeader>
                <ProjectTabs activeTab={tab} tabs={tabs} onTabClick={this.changeTab} />
                <div className="project-page-mobile_container">
                    <div className={`project-page-mobile_content project-page-mobile_tab-${tab}`}>
                        <div className="project-page-mobile_tab-content tab-scripts">
                            <ScriptsPanel
                                environment={environment}
                                projectName={projectName}
                                scriptName={scriptName} />
                        </div>
                        <div className="project-page-mobile_tab-content">
                            {scriptName && <ScriptHeader name={scriptName} />}
                            <ScriptAreaMobile
                                environment={environment}
                                scriptName={scriptName} />
                        </div>
                        <div className="project-page-mobile_tab-content">
                            <DebuggingChat
                                environment={environment}
                                expandSendBtn={true} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps({ projectsInfo }, ownProps) {
    const { projectName, scriptName } = ownProps.params;
    const projectId = getProjectId(projectName, projectsInfo.projects);

    return {
        projectId,
        projectName,
        scriptName,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getProjectDetail: (param) => asyncDispatch(actions.getProject, dispatch, param),
        clearChatMessages: () => dispatch(actions.clearChatMessages()),
        disconnectFromProject: () => dispatch(actions.disconnectFromProject()),
        changeEnvironment: (param) => dispatch(actions.changeEnvironment(param)),
        rememberProjectEnvironment: (param) => dispatch(actions.rememberProjectEnvironment(param)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectPageMobile);
